import { Button } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { NextPayment } from "./NextPayment";
import { NextBooking } from "./NextBooking";
import { Dispatch, SetStateAction } from "react";
import { PersonDetailsQuery } from "gql/generated";
import { Flex } from "styled-system/jsx";

type StorefrontInfoProps = {
  person: PersonDetailsQuery["personDetails"];
  setIsManualOrderModalOpen: Dispatch<SetStateAction<boolean>>;
};

export const StorefrontInfo = ({
  person,
  setIsManualOrderModalOpen,
}: StorefrontInfoProps) => {
  const { t } = useTranslation("people", {
    keyPrefix: "PERSON_DETAILS_MODAL.STOREFRONT_INFO",
  });

  return (
    <Flex flexDir="column" gap="200">
      <Button
        visual="accent.blue"
        onClick={() => setIsManualOrderModalOpen(true)}
      >
        {t("CTA_BUTTON")}
      </Button>
      <NextPayment person={person} />
      <NextBooking person={person} />
    </Flex>
  );
};
